import { memo } from 'react';

import { Box, BoxProps } from '@chakra-ui/react';

import { Text } from 'ui/Text';

interface CardPrimaryBadgeProps extends BoxProps {
  color: string;
  bg: string;
  label: string;
}

const CardPrimaryBadge = ({
  color,
  bg,
  label,
  ...props
}: CardPrimaryBadgeProps) => (
  <Box borderRadius='10px' py='5px' px='12px' bg={bg} {...props}>
    <Text
      fontSize='12px'
      color={color}
      textAlign='center'
      textTransform='uppercase'
    >
      {label}
    </Text>
  </Box>
);

export default memo(CardPrimaryBadge);
